<template>
  <div v-loading="loading">
    <el-alert
      type="info"
      :closable="false"
      show-icon
      title="此处维护的对公账户与客服微信二维码，会显示在各租户「套餐订阅」页。"
      style="margin-bottom: 16px"
    />
    <el-form :model="form" label-width="110px" style="max-width: 640px">
      <el-form-item label="收款户名">
        <el-input v-model="form.payeeName" placeholder="公司对公账户名称" maxlength="128" />
      </el-form-item>
      <el-form-item label="开户银行">
        <el-input v-model="form.bankName" placeholder="如：中国工商银行某某支行" maxlength="128" />
      </el-form-item>
      <el-form-item label="银行账号">
        <el-input v-model="form.bankAccount" placeholder="对公银行账号" maxlength="64" />
      </el-form-item>
      <el-form-item label="转账说明">
        <el-input
          v-model="form.contact"
          type="textarea"
          :rows="3"
          placeholder="展示在订阅页的补充说明，如：转账备注请填写企业名称"
          maxlength="500"
        />
      </el-form-item>
      <el-form-item label="客服微信二维码">
        <div class="qr-row">
          <img v-if="form.wechatQrUrl" class="qr-preview" :src="form.wechatQrUrl" alt="客服微信二维码" />
          <div class="qr-actions">
            <el-upload
              action="#"
              :http-request="elUploadHttpRequest"
              :show-file-list="false"
              :before-upload="beforeQrUpload"
              :on-success="onQrUpload"
              :on-error="() => { this.qrUploading = false }"
              accept="image/*"
            >
              <el-button size="small" type="primary" plain :loading="qrUploading">上传二维码</el-button>
            </el-upload>
            <el-button
              v-if="form.wechatQrUrl"
              size="small"
              type="text"
              style="color:#f56c6c"
              @click="clearQr"
            >清除</el-button>
            <div class="hint">用于「私有化部署 → 联系服务人员」弹窗展示，建议正方形图片，小于 2MB</div>
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
        <el-button @click="load">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getBillingAccount, saveBillingAccount } from '../../api/sys'
import { elUploadHttpRequest } from '../../utils/ossUpload'

export default {
  name: 'SysBillingAccount',
  data() {
    return {
      loading: false,
      saving: false,
      qrUploading: false,
      form: {
        payeeName: '',
        bankName: '',
        bankAccount: '',
        contact: '',
        wechatQrUrl: ''
      }
    }
  },
  created() {
    this.load()
  },
  methods: {
    elUploadHttpRequest,
    async load() {
      this.loading = true
      try {
        const res = await getBillingAccount()
        const data = res.data || {}
        this.form = {
          payeeName: data.payeeName || '',
          bankName: data.bankName || '',
          bankAccount: data.bankAccount || '',
          contact: data.contact || '',
          wechatQrUrl: data.wechatQrUrl || ''
        }
      } finally {
        this.loading = false
      }
    },
    beforeQrUpload(file) {
      const ok = file && file.type && file.type.indexOf('image/') === 0
      if (!ok) {
        this.$message.warning('请上传图片文件')
        return false
      }
      if (file.size > 2 * 1024 * 1024) {
        this.$message.warning('二维码图片请小于 2MB')
        return false
      }
      this.qrUploading = true
      return true
    },
    onQrUpload(res) {
      this.qrUploading = false
      const data = (res && res.data) || {}
      if (res && res.code && res.code !== 200) {
        this.$message.error(res.message || '上传失败')
        return
      }
      const url = data.url || ''
      if (!url) {
        this.$message.error('上传失败')
        return
      }
      this.form.wechatQrUrl = url
      this.$message.success('二维码已上传，请保存')
    },
    clearQr() {
      this.form.wechatQrUrl = ''
    },
    async save() {
      this.saving = true
      try {
        await saveBillingAccount({ ...this.form })
        this.$message.success('已保存')
        this.load()
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.qr-row { display: flex; align-items: flex-start; gap: 16px; }
.qr-preview {
  width: 120px;
  height: 120px;
  object-fit: contain;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
}
.qr-actions { flex: 1; min-width: 0; }
.hint { margin-top: 8px; color: #94a3b8; font-size: 12px; line-height: 1.5; }
</style>
